import { apiGet } from '../api.ts'
import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { createUrl } from '@/util/url.ts'
import { MINUTE } from '@/constant/time.ts'
import { AlertStatus } from './getUsers.ts'

interface IResGetUsers {}

export const apiGetUsersSimple = async ({}: IResGetUsers = {}) => {
    return await apiGet<IUser[]>(createUrl(`/protectee/simple`, {}))
}

const useQueryGetUsersSimple = (params?: IResGetUsers) => {
    return useQuery({
        queryKey: QueryCacheKeys.user.getUsersSimple(),
        refetchInterval: 1 * MINUTE,
        queryFn: async () => {
            const { data } = await apiGetUsersSimple({ ...params })
            return data
        }
    })
}

export default useQueryGetUsersSimple

export interface IUser {
    id: number
    name: string
    gender: number
    birthDate: string
    alertStatus?: AlertStatus
}
